import { render, staticRenderFns } from "./ListaPermissoes.vue?vue&type=template&id=a9dc946e&scoped=true"
import script from "./ListaPermissoes.vue?vue&type=script&lang=js"
export * from "./ListaPermissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dc946e",
  null
  
)

export default component.exports